import React from "react"
import styled from "styled-components"
import { RouteComponentProps } from "react-router"

const ErrorCopy = styled.h6`
  font-weight: 300;
  margin: 0;
  font-size: 12pt;
  max-width: 30em;
  text-align: center;
  color: #ffffff;
  line-height: 1.5;
  font-family: 'Arial';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  padding: 2em;
  align-items: center;
  justify-content: center;
  background: #000000;
  font-family: 'Arial';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`

const ErrorTitle = styled.span`
  color: rgb(182, 2, 2);
  font-size: 12pt;
  line-height: 1.5;
  margin-bottom: 1em;
  font-weight: 300;
  font-family: 'Arial';
`

const BackButton = styled.a`
  font-family: 'Arial';
  font-size: 12pt;
  line-height: 1.5;
  padding: 1em;
  color: #ffffff;
  font-weight: 300;
  text-decoration: none;
  
  &:hover {
    color: rgba(255, 255, 255, 0.8);
  }
`

const ERROR_MAP = {
  not_found: {
    title: "Not Found",
    message: "Channel not found, please try again",
  },
  unauthorized: {
    title: "Unauthorized",
    message:
      "Looks like this might be a private channel. Try again with a public channel",
  },
  not_a_channel: {
    title: "?",
    message:
      "This doesn't look like a channel, please try again and enter a URL from an Are.na channel.",
  },
  unknown: {
    title: "?",
    message: "Unknown error. Please try again",
  },
}

type ErrorPageProps = RouteComponentProps<{
  error: "unauthorized" | "not_found" | "not_a_channel" | "unknown"
}>

const ErrorPage: React.FC<ErrorPageProps> = ({
  match: {
    params: { error },
  },
}) => {
  return (
    <Container className="page">
      <ErrorTitle>{ERROR_MAP[error].title}</ErrorTitle>
      <ErrorCopy>{ERROR_MAP[error].message}</ErrorCopy>
      <BackButton href="/">˿</BackButton>
    </Container>
  )
}

export default ErrorPage
